import '@babel/polyfill';
import 'es6-symbol';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 测试登录 TODO
//import Login from '@/assets/mock/login';
//Login.install()

// ant-design
import '@/plugins/ant-design-vue.js';
import '@/registerServiceWorker';
import { iDelay, optionalChaining, iStorage } from '@/core';
iStorage.install();
// cookies
import * as tinyCookie from 'tiny-cookie';
// 全局过滤器
import '@/core/filter/install';
import { formatDate } from '@/core/filter';
// axios
import Axios from '@/service';
// 自定义全局加载组件
import iLoading from "@/components/iLoading/plugin.js";

Vue.config.productionTip = false

Vue.prototype.iStorage = iStorage;
Vue.prototype.$cookies = tinyCookie;
Vue.prototype.$bus = Vue.prototype.$bus || new Vue();
Vue.prototype.$iLoading = iLoading;
Vue.prototype.$$ = optionalChaining;
Vue.prototype.$iDelay = iDelay;
Vue.prototype.$formatDate = formatDate;
Vue.prototype.$ajax = new Axios();

new Vue({
	router,
	store,
	render: h => h(App),
	mounted() {
		window.addEventListener("message", this.receiveMessage, false);
	},
	methods: {
		// 其他站点通过iframe打开report站点，在此进行监听
		receiveMessage(event) {
			if(!event.data || event.data.from != "report") {
				return false;
			}
			const response = JSON.parse(event.data.response);
			const urlParams = JSON.parse(response.urlParams);
			const {
				path
			} = urlParams;
			this.iStorage.setAll(response)
			for(var key in response) {
				this.$cookies.set(key, response[key])
			}
			this.$store.commit("SETREPORTINFO", response)
            if(path && this.$route.path != path) { // 第一次指向path路由，使用生命周期函数做事
				this.$router.push({
					path: path
				})
			} else if(!path && this.$route.path != '/report') { // 如果未配置路由，默认走/report
                this.$router.push({
					path: "/report"
				})
			} else { // 在同一路由上切换菜单，那么就是用广播事件通知做事
                this.$root.$bus.$emit("onChangePortalMenu", {
					path: path || "/report"
				});
			}
			// 参考@/service备注说明
			Vue.prototype.$axios = new Axios();
		}
	}
}).$mount('#app')